import React, { useEffect, useState } from "react";
import ImageCard from "../../../components/card/ImageCard";
import AllButton from "../../../components/button/AllButton";
import { Link, useParams } from "react-router-dom";
import VideoService from "../../../services/video";
import timeFunction from "../../../functions/getTime";
import YoutubeVideo from "../../../functions/getYTVideo";
// import getVideoImage from "../../../functions/getImage";

export default function VideoDetail() {
  let { slug, lang } = useParams();
  let [videoData, setVideoData] = useState(null);
  let [anotherVideoData, setAnotherVideoData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getVideoData();
    getAnotherVideoData();
    // eslint-disable-next-line
  }, []);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  const getVideoData = async () => {
    try {
      let res = await VideoService.getVideoBySlug(`${slug}`);

      if (res[0]) {
        setVideoData(res[0]);
      } else {
        window.open(`/${lang}/video`, "_self");
      }
    } catch {
      console.error();
    }
  };

  const getAnotherVideoData = async () => {
    try {
      let res = await VideoService.getAnotherVideo(`${slug}`);

      if (res) {
        setAnotherVideoData(res);
      }
    } catch {
      console.error();
    }
  };

  const bannerName = () => {
    if (videoData && videoData.title) {
      return [
        { name: "Video collection", href: "/video" },
        {
          name:
            lang === "th"
              ? videoData?.title?.detail_TH
              : videoData?.title?.detail_EN,
        },
      ];
    }
    return []; // return an empty array if the condition is not met
  };

  return (
    <div className="service-info pt-[135px] lg:pt-[0px]">
      <div className="section">
        <div className="page-container">
          {/* บริการ แยก */}
          <div className="mt-[92px] mb-[300px]">
            <p className="text-body font-medium text-left">
              <a href={`/${lang}`} className="cursor-pointer">
                หน้าหลัก
              </a>
              {bannerName() &&
                bannerName().map((item, i) => (
                  <span
                    key={i}
                    className="capitalize cursor-pointer"
                    onClick={() => {
                      if (
                        item.href &&
                        window.location.pathname !== `/${lang}${item.href}`
                      ) {
                        window.open(
                          `/${lang}${item.href}`,
                          "_self"
                        );
                      }
                    }}
                  >
                    {" "}
                    / {item.name}
                  </span>
                ))}
            </p>

            {videoData && (
              <h1 className="text-heading font-bold text-slateGray text-left mt-[25px]">
                {lang === "th"
                  ? videoData.title.detail_TH
                  : videoData.title.detail_EN}
              </h1>
            )}

            <div className="mt-[10px] flex items-center gap-[30px]">
              {videoData && (
                <p className="text-body font-medium text-left">
                  {timeFunction.getTime(videoData.date, lang)}
                </p>
              )}
              {videoData?.publisher && (
                <div className="flex justify-center items-center gap-[12px]">
                  <div>
                    <div className="rounded-full w-[10px] h-[10px] xl:w-[14px] xl:h-[14px] bg-lightGray" />
                  </div>
                  <p className="text-body font-medium text-left">
                    {lang === "th"
                      ? videoData?.publisher.detail_TH
                      : videoData?.publisher.detail_EN}
                  </p>
                </div>
              )}
            </div>

            <div className="mt-[10px] flex gap-[16px]">
              <p className="text-small font-medium text-left text-blue">
                {videoData?.tag?.map((item, i) => (
                  <span key={i}>
                    <>
                      <span
                        className="cursor-pointer text-blue hover:underline"
                        onClick={() => {
                          window.open(
                            `/${lang}/search/${item.tag}`,
                            "_self"
                          );
                        }}
                      >
                        #{item.tag}
                      </span>
                      {i + 1 < videoData?.tag?.length && ", "}
                    </>
                  </span>
                ))}
              </p>
            </div>

            <div>
              {videoData ? (
                <YoutubeVideo link={videoData.video[0].href} />
              ) : (
                <div className="mt-[48px] mb-[36px] mx-[15px] w-full h-[640px] rounded-[12px] bg-lightGray" />
              )}

              <h1 className="text-subheading text-left">
                {lang === "th" ? "รายละเอียด" : "Detail"}
              </h1>
              {videoData && (
                <p className="mt-[18px] text-body font-medium text-left">
                  {lang === "th"
                    ? videoData.description.detail_TH
                    : videoData.description.detail_EN}
                </p>
              )}
              <hr className="my-[36px] h-[2px] w-full bg-darkGray" />

              <div>
                <div className="flex justify-between">
                  <h1 className="text-heading font-bold text-slateGray text-left">
                    วิดีโออื่นๆ
                  </h1>
                  <Link to={`/${lang}/video`}>
                    <AllButton lang={lang} />
                  </Link>
                </div>

                {anotherVideoData && (
                  <div
                    id="image-activity"
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:flex-row gap-[30px] mt-[68px]"
                  >
                    {anotherVideoData.slice(0, 3).map((item, i) => (
                      <div key={i}>
                        <ImageCard data={item} isVideo={true} lang={lang} />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
